import { transformFhirResponse } from '@/common/api/transformFhirResponse';

const FHIR_TTL = 15_000; // 15 seconds
const TERMINOLOGY_TTL = 7_200_000; // 2 hours

const inflight = new Map();
const cache = new Map();

function getKey(url, config) {
    const base = config.baseURL || '';
    return base + ':' + url;
}

function getTTL(config) {
    return config.terminology ? TERMINOLOGY_TTL : FHIR_TTL;
}

function buildSnapshot(res) {
    let rawData;
    if (res.originalData) {
        rawData = JSON.stringify(res.originalData);
    } else if (Array.isArray(res.data)) {
        rawData = JSON.stringify(res.data.map((item) => (item?.toJSON ? item.toJSON() : item)));
    } else if (res.data?.toJSON) {
        rawData = JSON.stringify(res.data.toJSON());
    } else {
        rawData = JSON.stringify(res.data);
    }
    return { status: res.status, headers: res.headers, total: res.total, rawData };
}

function rebuildResponse(snapshot) {
    const data = JSON.parse(snapshot.rawData);
    const res = { status: snapshot.status, headers: snapshot.headers, total: snapshot.total, data };
    return transformFhirResponse(res);
}

export function wrapWithDedup(originalGet) {
    return function dedupGet(url, config = {}) {
        return originalGet.call(this, url, config);
        // if (config._skipDedup) return originalGet.call(this, url, config);

        // const key = getKey(url, config);

        // const cached = cache.get(key);
        // if (cached) return Promise.resolve(rebuildResponse(cached.snapshot));

        // const pending = inflight.get(key);
        // if (pending) return pending.then((snapshot) => rebuildResponse(snapshot));

        // const snapshotPromise = originalGet
        //     .call(this, url, config)
        //     .then((res) => {
        //         inflight.delete(key);
        //         const snapshot = buildSnapshot(res);
        //         const ttl = getTTL(config);
        //         const timer = setTimeout(() => cache.delete(key), ttl);
        //         cache.set(key, { snapshot, timer });
        //         return snapshot;
        //     })
        //     .catch((err) => {
        //         inflight.delete(key);
        //         throw err;
        //     });

        // inflight.set(key, snapshotPromise);
        // return snapshotPromise.then((snapshot) => rebuildResponse(snapshot));
    };
}

export function clearDedupCache() {
    cache.forEach(({ timer }) => clearTimeout(timer));
    cache.clear();
    inflight.clear();
}
